export const DYNAMIC_ATTRIBUTE_EDITOR_PATH =
  "/settings-menu/dynamic-attributes-editor";
